module.exports = __webpack_public_path__ + "static/media/blog4.712de52e.jpg";